import { createReducer, on } from '@ngrx/store';
import { AdventActions } from '../actions/advent.actions';

export const configFeatureKey = 'advent';

export interface State {
  isAdvent: boolean;
  date?: number;
  hasClaimedBonus: boolean;
  keystone: any;
  adventBonus: string;
}

export const initialState: State = {
  isAdvent: false,
  hasClaimedBonus: false,
  keystone: null,
  adventBonus: '',
};

export const reducer = createReducer(
  initialState,
  on(AdventActions['[advent]SetAdvent'], (state, action) => {
    return {
      ...state,
      isAdvent: action.data,
    };
  }),
  on(AdventActions['[advent]SetAdventDate'], (state, action) => {
    return {
      ...state,
      date: action.data,
    };
  }),
  on(AdventActions['[advent]SetHasClaimedAdventBonus'], (state, action) => {
    return {
      ...state,
      hasClaimedBonus: action.data,
    };
  }),
  on(AdventActions['[advent]SetKeystoneAdvent'], (state, action) => {
    return { ...state, keystone: action.data };
  }),
  on(AdventActions['[advent]SetAdventBonus'], (state, action) => {
    return {
      ...state,
      adventBonus: action.data,
    };
  })
);
